import RNIdNowLibraryModule from './RNIdNowLibraryModule';

export function startIdent(token: string): string {
  return RNIdNowLibraryModule.startIdent(token);
}